import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		listBody_mobileContainer: {
			width: '100%',
			background: theme.palette.background.paper,
		},
		listBody_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		listBody_emptyBackground: {
			display: 'flex',
			flexDirection: 'column',
		},
		listBody_emptyBackgroundText: {
			display: 'flex',
			justifyContent: 'center',
			fontSize: theme.typography.h5.fontSize,
			color: alpha(theme.palette.primary.main, .3),
			marginTop: '15px',
		},
		listBody_emptyBackgroundIconBody: {
			display: 'flex',
			justifyContent: 'center',
		},
		listBody_emptyBackgroundIcon: {
			color: alpha(theme.palette.primary.main, .2),
			width: '100%',
			height: '100%',

			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				maxWidth: '20em',
				maxHeight: '20em',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				maxWidth: '10em',
				maxHeight: '10em',
			},
		},
		listBody_listItemsWrapper: {
			'& > div:last-child': {
				marginTop: theme.spacing(4),
				marginBottom: theme.spacing(0),
			},
			'& > div:first-child': {
				marginTop: theme.spacing(0),
				marginBottom: theme.spacing(4),
			},
			'& > div:nth-child(n+2):nth-last-child(n+2)': {
				margin: theme.spacing(4, 0),
			},
			'& > div:only-child': {
				margin: theme.spacing(2, 0),
			}
		},
		listBody_listItemCardsWrapperMobile: {
			'& > div:last-child': {
				marginTop: theme.spacing(2),
				marginBottom: theme.spacing(1),
			},
			'& > div:first-child': {
				marginTop: theme.spacing(1),
				marginBottom: theme.spacing(2),
			},
			'& > div:nth-child(n+2):nth-last-child(n+2)': {
				margin: theme.spacing(2, 0),
			},
			'& > div:only-child': {
				margin: theme.spacing(1, 0),
			}
		}
	});
});

export default useStyles;
